module.exports = __webpack_public_path__ + "themes/mf/img/scratch-cover.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/scratch-cover.png
// module id = 108
// module chunks = 3